export default __webpack_public_path__ + "static/plinth2017-14c76e04bc9c1d7993ff25fb64b10c8d.jpg";